import { triggerSnowplowImpressionEvent } from '@themuse/snowplow-js-client';
import { pagesToUse } from './snowPlowPages';

export const SnowplowImpressionTracker = ({
    component,
    tileType = null,
    modalType = null,
    buttonType = null,
    insertType = null,
    cardType = null,
    position = 'main',
    searchId = null,
    isExternal = false,
    companyId = null,
    pageSection = null,
    pageTab = null,
    pageType = null,
    tileEntityId = null,
    isSponsored = false,
    tileEntityUuid = null,
    tileOrder = 0,
    tileLocation = null,
    cardEntityId = null,
    cardEntityUuid = null,
    cardOrder = 0,
    cardLocation = null,
    fromCompanyJobsPage = false,
}) => {
    const userId = window.globalPageProps?.PAGE_PROPS?.session?.id;
    const baseJson = {
        // IMPRESSION INFO
        sp_impression_component: component,
        sp_impression_tile_type: tileType,
        sp_impression_modal_type: modalType,
        sp_impression_insert_type: insertType,
        sp_impression_button_type: buttonType,
        sp_impression_search_id: searchId,
        sp_impression_position: position,
        sp_impression_card_type: cardType,
        // TILE CONTENT INFO
        sp_tile_type: tileType,
        sp_tile_entity_id: tileEntityId,
        sp_tile_is_sponsored: isSponsored,
        sp_tile_entity_uuid: tileEntityUuid,
        sp_tile_order: tileOrder,
        sp_tile_location: tileLocation,
        sp_tile_company_id: companyId ? String(companyId) : null,
        // unnecessary for COMPANY JOBS PAGE
        ...(!fromCompanyJobsPage && {
            sp_card_type: cardType,
            sp_card_entity_id: cardEntityId,
            sp_card_entity_uuid: cardEntityUuid,
            sp_card_is_sponsored: isSponsored,
            sp_card_order: cardOrder,
            sp_card_location: cardLocation,
            sp_card_company_id: companyId ? String(companyId) : null,
        }),
    };
    const index = window.dataLayer.findIndex((obj) => 'sp_page_section' in obj);
    const pageData = {
        // PAGE INFO missing sp_page_page_company_id
        sp_page_is_external: isExternal,
        sp_page_type: pageType,
        sp_page_section: pageSection,
        sp_page_tab: pageTab,
        sp_user_id: userId,
        sp_user_logged_in: !!userId,
        // populating necessary info for event COMPANY JOBS PAGE
        ...(!fromCompanyJobsPage
            ? {
                  sp_page_sponsor_id: companyId ? String(companyId) : null,
              }
            : {
                  sp_page_page_company_id: companyId ? String(companyId) : null,
              }),
    };
    if (index >= 0) {
        window.dataLayer[index] = pageData;
    } else {
        window.dataLayer.push(pageData);
    }

    const element = document.createElement('div');
    element.setAttribute('data-tracking-props', JSON.stringify(baseJson));

    triggerSnowplowImpressionEvent(element);
};

export const convertMetricToSnowPlowImpressionTracker = (snowPlow) => {
    const page = window.location.pathname;
    // if the page is not in the pages to use return null
    if (!pagesToUse.includes(page)) return null;
    SnowplowImpressionTracker({
        ...snowPlow,
    });
};
